// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"GroupView_loadingOverlay__XCttY"};